// extracted by mini-css-extract-plugin
export var afterAngledSection = "Section-module--after-angled-section--ed0e0";
export var hasNoBottomPadding = "Section-module--has-no-bottom-padding--67207";
export var hasNoPadding = "Section-module--has-no-padding--d6990";
export var hasNoTopPadding = "Section-module--has-no-top-padding--1d562";
export var overflow = "Section-module--overflow--bf6b4";
export var section = "Section-module--section--16219";
export var smallPadding = "Section-module--small-padding--82fcc";